import Env from '@/services/env.service';

export default {
  sendEvent(gtag: any, category: string, action: string, label: string, value?: number) {
    if (!Env.get('VUE_APP_GA_ID')) {
      return;
    }

    const obj: any = {
      event_category: category,
      event_label: label
    };

    if (value) {
      obj.value = value;
    }

    try {
      gtag.event(action, obj);
    } catch (e) {
      console.error('Error sending GA action');
    }
  },
  setDimension(gtag: any, dimensionName: string, dimensionValue: string) {
    if (!Env.get('VUE_APP_GA_ID')) {
      return;
    }

    const obj: any = {};
    obj[dimensionName] = dimensionValue;

    try {
      gtag.set(obj);
    } catch (e) {
      console.error('Error setting GA dimension');
    }
  }
}